/* ------------------------------------------------------------------
   SAYSIRI - combination-aware variant availability

   Problem: the product section marks an option value as sold out by asking
   "does ANY variant with this value have stock?" - ignoring what the shopper
   has already picked. On the Keffiyeh Hoodie (Colour x Size x Zip, 56
   combinations, 6 in stock) a shopper selects Black, sees S / M / 3XL / 4XL
   still look available because Pink and White hold those sizes, picks one,
   and only then does the button say Out of Stock. The third option (Zip) was
   never marked at all.

   Fix: after every option click, recompute each value against the current
   selection. A value is available only if some in-stock variant matches that
   value AND every other currently selected option. Sold-out values get the
   .is-oos class the theme already styles, so they stay visible and slashed
   rather than disappearing.

   Purely additive - touches no existing markup or styles. Sold-out options
   stay clickable so a shopper is never trapped in a dead end.
   Remove the single script_tag line in theme.liquid to revert.
   ------------------------------------------------------------------ */

(function () {
  'use strict';

  var BUTTONS = '.spdp-colours [data-option-index], .spdp-sizes [data-option-index]';

  function init(varsEl) {
    var variants;
    try {
      variants = JSON.parse(varsEl.textContent);
    } catch (e) {
      return;
    }
    if (!variants || !variants.length) return;

    var scope = varsEl.closest('.shopify-section') || document;

    function buttons() {
      return Array.prototype.slice.call(scope.querySelectorAll(BUTTONS));
    }

    function currentSelection() {
      var sel = {};
      buttons().forEach(function (b) {
        if (b.classList.contains('is-selected')) {
          sel[b.getAttribute('data-option-index')] = b.getAttribute('data-value');
        }
      });
      return sel;
    }

    function refresh() {
      var sel = currentSelection();

      buttons().forEach(function (b) {
        var idx = parseInt(b.getAttribute('data-option-index'), 10);
        var val = b.getAttribute('data-value');

        var available = variants.some(function (v) {
          if (!v.available) return false;
          if (v.options[idx] !== val) return false;
          for (var key in sel) {
            if (!Object.prototype.hasOwnProperty.call(sel, key)) continue;
            var j = parseInt(key, 10);
            if (j === idx) continue;
            if (v.options[j] !== sel[key]) return false;
          }
          return true;
        });

        b.classList.toggle('is-oos', !available);

        var base = b.getAttribute('data-availability-label');
        if (base === null) {
          base = (b.getAttribute('aria-label') || b.textContent || '').trim();
          base = base.replace(/\s+—\s+out of stock$/i, '');
          b.setAttribute('data-availability-label', base);
        }
        b.setAttribute('aria-label', available ? base : base + ' — out of stock');
      });
    }

    scope.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || typeof t.closest !== 'function') return;
      if (!t.closest('[data-option-index]')) return;
      window.setTimeout(refresh, 0);
    });

    refresh();
  }

  function boot() {
    var nodes = document.querySelectorAll('[id^="spdpVariants-"]');
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
